import * as React from 'react';

function IconLanguageRuSmall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="language-ru-small-mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} rx={4} fill="#C4C4C4" />
      </mask>
      <g mask="url(#language-ru-small-mask0)">
        <path
          d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
          fill="white"
        />
        <path d="M29 0H-4V8H29V0Z" fill="#F0F5FF" />
        <path d="M29 8H-4V16H29V8Z" fill="#0060CF" />
        <path d="M29 16H-4V24H29V16Z" fill="#FF564E" />
      </g>
    </svg>
  );
}

export default IconLanguageRuSmall;
